import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=a48d5cbc&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=a48d5cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48d5cbc",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationPlugin/Notification.vue
// module id = 2790
// module chunks = 31